import React, { useEffect, useState } from 'react'
import CarPickup from '../../image/car_pickup.png'
import {
    TimerContainer,
    Progress,
    CarIcon,
    PickupBlock,
    PickupText,
} from './CountdownPickupTimer.styled'
import messages from './CountdownPickupTimer.messages'
import { FormattedMessage, FormattedRelativeTime } from 'react-intl'
import { Vehicle } from '../../entities/vehicle/Vehicle'
import VehicleMapModal from '../vehicle-map-modal/VehicleMapModal'

export interface IOwnProps {}
export interface IStateProps {
    vehicle?: Vehicle
}
export interface IDispatchProps {}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const CountdownPickupTimer: React.FC<IProps> = (props) => {
    const { vehicle } = props
    const [progress, setProgress] = useState<number | undefined>(
        vehicle?.progress()
    )
    const [isMapModalOpen, setIsMapModalOpen] = React.useState(false)

    // if (vehicle) {
    //     console.log(progress)
    //     console.log('vehicle', vehicle?.arrivesIn > vehicle.arrivalDuration)
    // }

    useEffect(() => {
        return () => {
            if (!vehicle || !progress || progress <= 0) {
                setIsMapModalOpen(false)
            }
        }
    }, [vehicle, progress])

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(vehicle?.progress())

            if (!vehicle || vehicle.progress() <= 0) {
                clearInterval(interval)
            }
        }, 1000)

        return () => {
            clearInterval(interval)
        }
    }, [vehicle])

    // TODOILYA ILYA FIX
    if (!vehicle || vehicle?.arrivesIn > vehicle.arrivalDuration) {
        return null
    }

    if (!progress || progress <= 0) {
        return null
    }

    const handlePickupBlockClick = () => {
        setIsMapModalOpen(true)
    }

    const handleMapModalClose = () => {
        setIsMapModalOpen(false)
    }

    return (
        <>
            <PickupBlock>
                <TimerContainer onClick={handlePickupBlockClick}>
                    <CarIcon src={CarPickup} alt='Pickup timer' />

                    <Progress
                        variant='determinate'
                        size={64}
                        color='warning'
                        value={progress || vehicle.progress()}
                    />
                </TimerContainer>

                <PickupText>
                    <FormattedRelativeTime
                        value={vehicle.arrivesIn}
                        updateIntervalInSeconds={-1} // disable auto update, but apply smart formatting
                        style='short'
                    >
                        {(formattedDate) => (
                            <FormattedMessage
                                {...messages.pickupIn}
                                values={{
                                    count: formattedDate,
                                }}
                            />
                        )}
                    </FormattedRelativeTime>
                </PickupText>
            </PickupBlock>

            <VehicleMapModal
                onClose={handleMapModalClose}
                open={isMapModalOpen}
                header={() => (
                    <>
                        <CarIcon src={CarPickup} alt='Pickup timer' />

                        <FormattedRelativeTime
                            value={vehicle.arrivesIn}
                            updateIntervalInSeconds={-1} // disable auto update, but apply smart formatting
                            style='short'
                        >
                            {(formattedDate) => (
                                <FormattedMessage
                                    {...messages.pickupIn}
                                    values={{
                                        count: formattedDate,
                                    }}
                                />
                            )}
                        </FormattedRelativeTime>
                    </>
                )}
            />
        </>
    )
}

export default CountdownPickupTimer
